import React from 'react';
import { Check } from 'lucide-react';

/**
 * Multi-select chip component for sandwich type preferences
 */
const PreferencesChips = ({ options, value = [], onChange }) => {
  const toggleOption = (option) => {
    if (value.includes(option)) {
      onChange(value.filter(v => v !== option));
    } else {
      onChange([...value, option]);
    }
  };

  return (
    <div className="flex flex-wrap gap-2 justify-center">
      {options.map((option) => {
        const isSelected = value.includes(option);
        return (
          <button
            key={option}
            onClick={() => toggleOption(option)}
            className={`
              flex items-center gap-2 px-4 py-2 rounded-full text-sm font-medium transition-all
              ${isSelected
                ? 'bg-passion-red text-white shadow-md scale-105'
                : 'bg-white text-gray-700 border border-gray-300 hover:border-passion-red hover:text-passion-red'
              }
            `}
            aria-pressed={isSelected}
            aria-label={`${isSelected ? 'Deselect' : 'Select'} ${option}`}
          >
            {isSelected && <Check size={16} aria-hidden="true" />}
            <span>{option}</span>
          </button>
        );
      })}
    </div>
  );
};

export default PreferencesChips;

